import { useTranslation } from 'react-i18next'
import { parseI18nMessage } from '~/shared/lib/i18n'

export const useParserI18nMessage = () => {
  const { t } = useTranslation()

  const parserI18nMessage = (message?: string) => {
    if (!message) return ''

    const { key, values } = parseI18nMessage(message)
    return t(key, values)
  }

  return {
    parserI18nMessage,
  }
}
